import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type HelpCategoryDto = {
  id: string;
  nameEn: string;
  nameFr: string;
  descriptionEn?: string;
  descriptionFr?: string;
  slug: string;
  icon?: string;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
};

export type HelpCategoryWithCountDto = HelpCategoryDto & {
  articleCount: number;
};

export const GET_HELP_CATEGORIES_QUERY_KEY = ['help-categories'];
export const GET_PUBLIC_HELP_CATEGORIES_QUERY_KEY = (lang: string) => ['help-public-categories', lang];

export const useHelpCategories = () => {
  const client = useApiClient();
  return useQuery({
    queryKey: GET_HELP_CATEGORIES_QUERY_KEY,
    queryFn: () => client.fetchApi<HelpCategoryDto[], {}>({ endpoint: 'help/admin/categories', method: 'GET' }),
    staleTime: 5 * 60 * 1000,
  });
};

export const usePublicHelpCategories = (lang: string) => {
  const client = useApiClient();
  return useQuery({
    queryKey: GET_PUBLIC_HELP_CATEGORIES_QUERY_KEY(lang),
    queryFn: () => client.fetchApi<HelpCategoryWithCountDto[], {}>({ endpoint: `help/categories?lang=${lang}`, method: 'GET' }),
    staleTime: 5 * 60 * 1000,
  });
};
